import {useEffect} from "react";

export function useMountEffect(fun) {
    useEffect(fun, [])
}
